import {createRoot} from 'react-dom/client';
import {BrowserRouter} from "react-router-dom";
import App from './App.jsx';
import React from 'react';
import './index.css';
import { initializeTheme } from './utils/theme';

// Initialize theme before React renders to prevent flash
initializeTheme();

createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </React.StrictMode>
);
